import { FormSection, formatDateTime, formatNumber } from "@omnabase/ui";
import { creditLineLabel, type CreditHistoryLine } from "@omnabase/shared";

/** Settings › Billing › Credit history (M7 round two; M14 round five, the founder: "Credit history becomes a table: Date, What (reply /
 *  investigation / pack / reload / adjustment), Ticket, Credits (±), Balance after"): every grant and every charge, newest first, each with
 *  the balance right after it (the API's `balanceAfter`). A line's note (a grant's reason) stays with its kind in What. */
const signed = (n: number) => `${n > 0 ? "+" : n < 0 ? "−" : ""}${formatNumber(Math.abs(n))}`;

export function CreditHistory({ ledger }: { ledger: CreditHistoryLine[] | null }) {
  return (
    <FormSection title="Credit history" intro="Every grant and every charge, newest first.">
      {!ledger || ledger.length === 0 ? <p className="ob-form-row__help">Nothing yet.</p> : (
        <div className="ob-dtable-card">
          <table className="ob-dtable ob-credit-history" aria-label="Credit history">
            <thead><tr><th>Date</th><th>What</th><th className="ob-dtable__col--below-420">Ticket</th><th className="ob-dtable__num">Credits</th><th className="ob-dtable__num ob-dtable__col--below-540">Balance after</th></tr></thead>
            <tbody>{ledger.map((r) => (
              <tr key={r.id}>
                <td className="ob-dtable__muted">{formatDateTime(r.at)}</td>
                <td className="ob-dtable__grow"><span className="ob-dtable__who"><span title={creditLineLabel(r)}>{creditLineLabel(r)}</span>{r.note && <span className="ob-dtable__email" title={r.note}>{r.note}</span>}</span></td>
                <td className="ob-dtable__muted ob-dtable__col--below-420">{r.ticketNumber !== null ? `#${r.ticketNumber}` : "—"}</td>
                <td className="ob-dtable__num">{signed(r.amount)}</td>
                <td className="ob-dtable__num ob-dtable__col--below-540">{formatNumber(r.balanceAfter)}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </FormSection>
  );
}
